import { AxiosInstance } from 'axios';

import { UserActivityColumns } from '../../../../../admin/columns/user-activity-columns.enum';
import { axios } from '../../../../api/axios-instance';
import { userActivitiesEndpoints } from '../../../../constants';
import { DateFilter } from '../../../../enum/date-filter.enum';
import { ProgressStatusesEnum } from '../../../../enum/progress-statuses.enum';
import { PaginationRequest } from '../../../../types/pagination-request';
import { SortRequest } from '../../../../types/sort-request';
import {
  CreateUserActivityInput,
  UserActivitiesResponse,
} from '../../../user/schemas/user-activity.schema';
import { ModalActivity, UserActivity } from '../../entities/user-activity';

class UserActivitiesApi {
  #requestInstance: AxiosInstance;

  constructor(axiosInstance: AxiosInstance) {
    this.#requestInstance = axiosInstance;
  }

  create = async (userActivity: CreateUserActivityInput): Promise<UserActivity> => {
    return this.#requestInstance.post(userActivitiesEndpoints.userActivities, userActivity);
  };
  createDone = async (userActivity: CreateUserActivityInput): Promise<UserActivity> => {
    return this.#requestInstance.post(userActivitiesEndpoints.doneUserActivities, userActivity);
  };

  deleteUserActivity = async (id: number): Promise<void> => {
    return this.#requestInstance.delete(userActivitiesEndpoints.getUserActivityById(id));
  };

  getUserActivityById = async (id: number): Promise<UserActivitiesResponse> => {
    return this.#requestInstance.get(userActivitiesEndpoints.getUserActivityById(id));
  };

  getUserActivitiesById = async (
    id: number,
    data?: PaginationRequest &
      SortRequest<DateFilter> & { status?: ProgressStatusesEnum | ProgressStatusesEnum[] }
  ): Promise<UserActivitiesResponse> => {
    return this.#requestInstance.get(userActivitiesEndpoints.getUserActivitiesById(id), {
      params: data,
    });
  };

  getAllUsersActivities = async (
    data?: PaginationRequest & SortRequest<UserActivityColumns> & { status: ProgressStatusesEnum }
  ): Promise<UserActivitiesResponse> => {
    return this.#requestInstance.get(userActivitiesEndpoints.allUsersActivities, { params: data });
  };

  getPendingUsersActivities = async (limit: number): Promise<UserActivity[]> => {
    return this.#requestInstance.get(userActivitiesEndpoints.pendingUsersActivities, {
      params: { limit },
    });
  };

  updateUserActivity = async (activity: ModalActivity): Promise<UserActivity> => {
    return this.#requestInstance.patch(
      userActivitiesEndpoints.getUserActivityById(activity.id),
      activity
    );
  };

  updateUserActivityStatus = async ({
    id,
    status,
  }: {
    id: number;
    status: ProgressStatusesEnum;
  }): Promise<UserActivity> => {
    return this.#requestInstance.patch(userActivitiesEndpoints.getUserActivityStatusById(id), {
      status,
    });
  };

  updateStatusForManyUserActivities = async ({
    ids,
    status,
  }: {
    ids: number[];
    status: ProgressStatusesEnum;
  }): Promise<UserActivity[]> => {
    return this.#requestInstance.patch(userActivitiesEndpoints.getAllUsersActivity, {
      ids,
      status,
    });
  };
}

export const userActivitiesApi = new UserActivitiesApi(axios);
